var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "hsarticle",
      class: [
        _vm.size ? "hsarticle-" + _vm.size : "",
        { "not-subscribe": _vm.notSubscribe },
      ],
    },
    [
      _vm.tags
        ? _c(
            "div",
            { staticClass: "hsarticle__tags" },
            [
              _vm.classification
                ? _c("Tag", {
                    class: _vm.setTagColour(_vm.classification),
                    attrs: {
                      text: _vm.classification,
                      color: "green",
                      background: "gray",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(
                _vm.tags.filter((item, index) => index < 3),
                function (tag, index) {
                  return _c("Tag", {
                    key: index,
                    class:
                      _vm.watchlistTags &&
                      _vm.watchlistTags.find((el) => tag.tid === el)
                        ? "red"
                        : null,
                    attrs: {
                      text: tag.title,
                      color: "brightgreen",
                      background: "gray",
                      link: _vm.setTagURL(tag, "jurisdictions"),
                      uuid: tag.uuid,
                      tid: tag.tid,
                    },
                  })
                }
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "hsarticle-bottom" }, [
        _vm.download
          ? _c(
              "div",
              { staticClass: "hsarticle__download" },
              [_c("Download", { attrs: { file: _vm.download } })],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hsarticle__title" },
        [
          _vm.checkHsAccess(_vm.tags)
            ? _c("nuxt-link", {
                staticClass: "hsarticle__title-link",
                attrs: { to: _vm.link, target: "_blank" },
                domProps: { innerHTML: _vm._s(_vm.title) },
              })
            : _c(
                "nuxt-link",
                {
                  staticClass: "unauthorised hsarticle__title-link",
                  attrs: { to: _vm.link },
                },
                [_vm._v(_vm._s(_vm.noAccessShort))]
              ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.desc && _vm.checkHsAccess(_vm.tags)
        ? _c("div", {
            staticClass: "hsarticle__desc",
            domProps: { innerHTML: _vm._s(_vm.externalLinks(_vm.desc)) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.desc && !_vm.checkHsAccess(_vm.tags)
        ? _c("div", { staticClass: "unauthorised hsarticle__desc" }, [
            _vm._v("\n    " + _vm._s(_vm.noAccessShort) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.date
        ? _c(
            "div",
            { staticClass: "hsarticle__date" },
            [_c("Date", { attrs: { text: _vm.date, author: _vm.author } })],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }